import { Component,  OnInit} from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';


@Component({
    selector: 'app-provider-token',
    templateUrl: './provider-token.component.html',
    styleUrls: ['./provider-token.component.scss'],
    standalone: false
})


export class ProviderTokenComponent implements OnInit {
  PORTAL_BAT_ZIP_FILE: any;
  PORTAL_BAT_ZIP_FILE_EgyptTrust:any;

   constructor(
      private configService : ConfigService
    
    ) {
     const config = this.configService.config;
     this.PORTAL_BAT_ZIP_FILE = config.PORTAL_BAT_ZIP_FILE;
     this.PORTAL_BAT_ZIP_FILE_EgyptTrust=config.PORTAL_BAT_ZIP_FILE_EgyptTrust
    }
  ngOnInit(): void {}
    downloadInternationalZip() {
    if (!this.PORTAL_BAT_ZIP_FILE) {
      alert('Download URL not available');
      return;
    }

    window.location.href = this.PORTAL_BAT_ZIP_FILE;
  }

    downloadEgyptTrustZip() {
    if (!this.PORTAL_BAT_ZIP_FILE_EgyptTrust) {
      alert('Download URL not available');
      return;
    }

    window.location.href = this.PORTAL_BAT_ZIP_FILE_EgyptTrust;
  }
}
 
